import React, {PropTypes, Component} from 'react';

class InflunetOpenApp extends Component {
  propTypes: {
    link: React.PropTypes.string.isRequired
  };

  render() {
    return (
      <a href={this.props.link} style={this.styles.openApp}>
        OPEN APP
      </a>
    );
  }

  styles = {
    openApp: {
      fontSize: '11px',
      width: '72px',
      fontWeight: '500'
    }
  }
};

export default InflunetOpenApp;



// WEBPACK FOOTER //
// ./src/advocate/components/influnet_promotion/open_app.jsx